import { style } from 'typestyle'
import { important } from 'csx'
export const pt0i = style({ paddingTop: important('0px') })
